// ** React Imports
import { Fragment, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

// ** Third Party Components
import classnames from "classnames"

// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
// import { handleContentWidth, handleMenuCollapsed, handleMenuHidden } from '@store/actions/layout'
import "../../styles/layout.scss"
import Drawer from "./Drawer"
import Footer from "./Footer"
import Navbar from "./Navbar"
import SideBar from "./Navigator"
import logo from "../../assets/images/logo/Group.svg"
import { useNavigate } from "react-router-dom"
import { setCollapsed } from "../../redux/actions"
// ** Styles
// import 'animate.css/animate.css'

const LayoutWrapper = (props) => {
  const { layout, children, appLayout, wrapperClass, transition, routeMeta } = props

  const dispatch = useDispatch()
  const [sidebarIsOpen, setSidebarOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    dispatch(setCollapsed(sidebarIsOpen))
  }, [sidebarIsOpen]);

  const isReportsPage = location.pathname.endsWith('reports')
  const LIGHT_BLUE_BG_MODULES = ['factoryfileupload', 'operations', 'cmm', 'caq']
  const hasLightBlueBg = LIGHT_BLUE_BG_MODULES.some((m) => location.pathname.endsWith(m))

  return (
    <div className='App'>
      <Drawer SideBar={SideBar} handleCollapsed={setSidebarOpen} sidebarIsOpen={sidebarIsOpen} />
      <div className='layout'>
        <div className='data box-shadow-1 d-none d-lg-block bg-white'>
          <div className={`mt-80`}>
            <div className='sidebar-header box-shadow-1  d-flex flex-row align-item-center justify-content-center h-80 bg-white'>
              <img src={logo} alt='Login V2' className={`${sidebarIsOpen ? "mx-auto" : ""}`} />
              <h3 className={`${sidebarIsOpen ? "d-none" : ""}`}>AVDHAAN</h3>
            </div>
          </div>
          <div className='aside b-0'>
            <SideBar toggleSidebar={setSidebarOpen} sidebarIsOpen={sidebarIsOpen} />
          </div>
        </div>
        <Navbar handleToggle={setSidebarOpen} sidebarIsOpen={sidebarIsOpen} />
        <main
          className="mt-1"
          style={{
            background: isReportsPage
              ? "var(--page-bg-reports)"
              : hasLightBlueBg
                ? "var(--page-bg-lightblue)"
                : "var(--page-bg-default)"
          }}
        >
          <div className='m-4'>
            <div className="parent-container"> {children}</div>
            <Footer />
          </div>
        </main>
      </div>
    </div>
  )
}

export default LayoutWrapper
